import { formatCount } from "@/lib/format";
import type { Pagination as Page } from "@/lib/paginate";

type Props = {
  page: Page<unknown>;
  /** Eindeutiger Name der Tabelle für Screenreader, z. B. „Query-Fan-outs“. */
  label: string;
  onPage: (page: number) => void;
};

const BUTTON = "h-11 min-w-11 rounded-md border border-field bg-white px-3 text-[13px] disabled:opacity-40";

/** Seitennavigation unter einer Tabelle. Bei nur einer Seite wird nichts angezeigt. */
export function Pagination({ page, label, onPage }: Props) {
  if (page.pages <= 1) return null;
  return (
    <nav
      aria-label={`Seiten ${label}`}
      className="flex flex-wrap items-center justify-between gap-3 border-t border-neutral-bg px-5 py-2"
    >
      <span aria-live="polite" className="text-[13px] text-muted">
        {formatCount(page.from)}–{formatCount(page.to)} von {formatCount(page.total)} · Seite {formatCount(page.page)} von{" "}
        {formatCount(page.pages)}
      </span>
      <div className="flex flex-wrap items-center gap-1.5">
        <button type="button" onClick={() => onPage(1)} disabled={page.page === 1} className={BUTTON}>
          Erste Seite
        </button>
        <button type="button" onClick={() => onPage(page.page - 1)} disabled={page.page === 1} className={BUTTON}>
          Vorherige Seite
        </button>
        <button type="button" onClick={() => onPage(page.page + 1)} disabled={page.page === page.pages} className={BUTTON}>
          Nächste Seite
        </button>
        <button type="button" onClick={() => onPage(page.pages)} disabled={page.page === page.pages} className={BUTTON}>
          Letzte Seite
        </button>
      </div>
    </nav>
  );
}
